
//////////////////////////////////////////////
// recommendationForm

var _activeRecommendationFormPage = null;
var _recommendationRadioUrl = null;

function initRecommendationForm(){
	if($(".recommendationForm").length > 0){

		$(".recommendationForm").find(".recommendationForm__page").hide();
		$(".recommendationForm").find(".recommendationForm__footer").hide();
		$(".recommendationForm__loader").hide();
		
		//start button
		$("#recommendationFormButtonStart").click(function(){
			startRecommondationForm();
		});
		/*
		$(".recommendationForm__header").click(function(){
			if(!$(this).hasClass("started")){
				startRecommondationForm();
			}
		});
		*/
		
		//close button
		$("#recommendationFormButtonClose").click(function(){
			closeRecommondationForm();
		});

		//prev / next button
		$(".recommendationFormButtonPrev").click(function(){
			if(_activeRecommendationFormPage){
				var prevId = _activeRecommendationFormPage.attr("data-prev");
				if(prevId != ""){
					showRecommendationFormPage(prevId);
				}
			}
		});
		$(".recommendationFormButtonNext").click(function(){
			if(_activeRecommendationFormPage){
				_recommendationRadioUrl = null;

				//search for special url radiobutton
				$(".recommendationForm__radio--url").each(function(){
					if ($(this).is(':checked')) {
						_recommendationRadioUrl = $(this).attr("data-url");
					}
				});
				
				if(_recommendationRadioUrl && _recommendationRadioUrl != ""){

					//special tracking
					if(window.dataLayer && window.dataLayer.length) {
						trackEvent("only-bond-and-next-button", "1");
					}

					//load external page for special radio selection
					//window.location.href = _recommendationRadioUrl;
					window.open(_recommendationRadioUrl,'_blank');
				}
				else{
					//show next step
					var nextId = _activeRecommendationFormPage.attr("data-next");
					if(nextId != ""){
						showRecommendationFormPage(nextId);
					}
				}
				
			}
		});

		// radio buttons
		$(".recommendationForm__radio").change(handleRecommendationFormAnswer);
		$(".recommendationForm__select").change(
			function(){
				//console.log("recommendationForm__select val:" + $(this).val());
				if($(this).val() != ""){
					handleRecommendationFormAnswer();
				}
			}
		);
	}
}

function showRecommendationFormPage(id){
	//console.log("showRecommendationFormPage("+id+")");
	_activeRecommendationFormPage = $("#" + id);
	$('.recommendationFormButtonNext').attr('id', id + '-next')
	$('.recommendationFormButtonPrev').attr('id', id + '-back')
	$(".recommendationForm").find(".recommendationForm__page").hide();
	updateRecommendationFormProgress(_activeRecommendationFormPage.attr("data-progress"));
	updateRecommendationFormFooter(_activeRecommendationFormPage.attr("data-page"));
	


	if(_activeRecommendationFormPage.hasClass("recommendationForm__result")){
		$(".recommendationForm__loader").show();
		$(".recommendationForm__footer").hide();
	
		$("#recommendationFormPage4").children(".recommendationForm__result-content").html("");
		_activeRecommendationFormPage.find(".recommendationForm__restart").hide();
		_activeRecommendationFormPage.show();
		
		var rForm = $(".recommendationForm").children(".checkForm");
    	var url = rForm.attr('action');
		
		$.ajax({
			type: "POST",
			url: url,
			data: rForm.serialize(),
			success: function(data)
			{
				//console.log("recommendationForm ajax success");
				//console.log("data:" + data);
				_activeRecommendationFormPage = $("#recommendationFormPage4");
				_activeRecommendationFormPage.children(".recommendationForm__result-content").html(data);
				initRecommendationFormResult(_activeRecommendationFormPage);
				_activeRecommendationFormPage.find(".recommendationForm__restart").show();
				$(".recommendationForm__loader").hide();
			}
        });
	}
	else{
		_activeRecommendationFormPage.show();
	
		if(_activeRecommendationFormPage.attr("id") == "recommendationFormPage3"){
			//last question is always answered
			handleRecommendationFormAnswer();
		}
	}
}

function initRecommendationFormResult($page){
	
	$page.find(".recommendationForm__result-detail-switch").removeClass("opened");
	$page.find(".recommendationForm__result-checklist").hide();

	$(".recommendationForm__suggestion-container").slick({
        responsive: [
            {
                breakpoint: 99999,
                settings: "unslick"
            },
            {
                breakpoint: _breakpointMedium,
                settings: {
                    dots: false,
                    infinite: true,
                    draggable: true,
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '0',
                    variableWidth: false,
                    adaptiveHeight: true,
                    focusOnSelect: true,
                    prevArrow: slickPrevArrowCode,
                    nextArrow: slickNextArrowCode
                }
            }
        ]
	});
	
	/*
	$page.find(".recommendationForm__result-detail-switch").each(function(){
		$(this).unbind();
		$(this).click(function(){
			$(this).toggleClass("opened");
			var $d = $(this).closest(".recommendationForm__result-detail");
			$d.find(".recommendationForm__result-checklist").toggle();
		});
		$(this).on("keydown", handleKeyDownForClick);
	});
	*/
	$page.find(".recommendationForm__result-detail-header").each(function(){
		$(this).unbind();
		$(this).click(function(){
			$(this).find(".recommendationForm__result-detail-switch").toggleClass("opened");
			var $d = $(this).closest(".recommendationForm__result-detail");
			$d.find(".recommendationForm__result-checklist").toggle();
		});
		$(this).on("keydown", handleKeyDownForClick);
	});
	
	$page.find(".recommendationForm__restart-link").each(function(){
		$(this).unbind();
		$(this).click(function(e){
			e.preventDefault();
			closeRecommondationForm();
			startRecommondationForm();
		});
		$(this).on("keydown", handleKeyDownForClick);
	});

}

function updateRecommendationFormProgress(p){
	$(".recommendationForm__progress").css("width", p + "%");
	$(".recommendationForm__progress").show();
}

function handleRecommendationFormAnswer(){
	_activeRecommendationFormPage.removeClass("answered");
	_activeRecommendationFormPage.addClass("answered");
	$(".recommendationFormButtonNext").removeClass("disabled");
}

function updateRecommendationFormFooter(p){

	//prev
	$(".recommendationFormButtonPrev").removeClass("disabled");
	if(p == 1){
		$(".recommendationFormButtonPrev").addClass("disabled");
	}

	//next
	$(".recommendationFormButtonNext").removeClass("disabled");
	if(!_activeRecommendationFormPage.hasClass("answered")){
		$(".recommendationFormButtonNext").addClass("disabled");
	}
	
	$(".recommendationForm").find(".recommendationForm__footer").show();
}

function startRecommondationForm(){
	
	showRecommendationFormPage("recommendationFormPage1", 1);
	$(".recommendationForm__header").removeClass("started");
	$(".recommendationForm__header").addClass("started");
	$("#recommendationFormButtonStart").hide();
	$("#recommendationFormButtonClose").show();
	
}

function closeRecommondationForm(){
	$("#recommendationFormButtonStart").show();
	$("#recommendationFormButtonClose").hide();
	
	showRecommendationFormPage("recommendationFormPage1", 1);
	$(".recommendationForm__page").hide();
	$(".recommendationForm__progress").hide();
	$(".recommendationForm__footer").hide();
	
	$(".recommendationForm__radio").prop("checked", false);

	var firstOption = $("select.recommendationForm__select option:first").val();
	var firstLabel = $("select.recommendationForm__select option:first").text();
	$("select.recommendationForm__select").val(firstOption);
	$(".nice-select.recommendationForm__select").children(".current").html(firstLabel);
	$(".nice-select.recommendationForm__select").find("li").removeClass("selected");
	$(".nice-select.recommendationForm__select").find("li").removeClass("focus");
	
	//console.log("closeRecommondationForm() firstOption:" + firstOption + " firstLabel:" + firstLabel);
	
	$(".recommendationForm__page").removeClass("answered");
	
	$([document.documentElement, document.body]).animate({
		scrollTop: $(".recommendationForm").offset().top-50
	}, 250);

	setTimeout(function(){
		$(".recommendationForm__header").removeClass("started");
	}, 250)
	
}